'use strict';

export default (API) => ({
    texts: {
        get: (establishmentId, lang = '') => {
            const url = 'v3/establishments/' + establishmentId + '/texts' + (lang ? '/' + lang : '');
            const request = API.http.get(url);
            return API.handleError(request);
        },

        updateTexts: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/texts';
            const request = API.http.put(url, params);
            return API.handleError(request);
        }
    }
});
